import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import 'moment/locale/es';

@Pipe({ name: 'dateFormatPipe' })
export class DateFormatPipe implements PipeTransform {
    transform(date: Date, format: string = 'D MMM YYYY'): string {
        const m = moment.utc(date).format('D MMM YYYY');
        return m;
    }
}
